/**
 * Internal Dependencies
 */
import themeOptions from './components/theme-options';
import '../scss/main.scss';
import './vendor/match.js';
import './search.js';

( function() {
	themeOptions();

	setActiveNav();
	initOffsiteLinks();
	formRedirect();

	const $ = jQuery;

	$( '.match' ).matchHeight();

	jQuery( '#00N5a00000DgvdO' ).zmultiselect( {

		filter: false,
		filterResult: false,
		selectAll: false,
		placeholder: 'Select one or more',
		live: '#00N5a00000DgvdO',
	} );

	//set the visibility to visible and display to block for field 00N5a00000DgvdO  but make the height 0 so it cant be seen
	jQuery( '#00N5a00000DgvdO' ).css( {
		'visibility': 'visible',
		'display': 'block',
		'height': '0',
		'width': '0',
		'color': 'transparent',
		'margin-bottom': '-41px',
		'margin-top': '28px', 
		'margin-left': '30px',
	} );

	jQuery( '#00N5a00000DgvdO' ).find( 'option' ).each( function() {
		jQuery( this ).css( 'color', 'transparent' );
	} );


	// $(".med-form").submit(function(e) {
	// 	// Implement your custom validation logic here
	// 	if (!isMultiselectValid()) {
	// 	  e.preventDefault();
	// 	  alert("Please select at least one option.");
	// 	}
	//   });
  
	//   function isMultiselectValid() {
	// 	// Implement your validation logic here
	// 	// Check if at least one option is selected in your multiselect
	// 	// Return true if valid, false otherwise
	// 	return false
	//   }



	document.addEventListener( 'DOMContentLoaded', function() {
		const inputs = document.querySelectorAll( 'input' );

		inputs.forEach( ( input ) => {
			input.addEventListener( 'blur', () => {
				if ( ! input.checkValidity() ) {
					input.classList.add( 'show-invalid' );
				} else {
					input.classList.remove( 'show-invalid' );
				}
			} );
		} );
	} );



	//when users first visit the site, check for hcp cookie. if it doesn't exist, show the hcp modal
	if ( ! getCookie( 'hcp' ) ) {
		hcpModal();
	}

	if ( getCookie( 'hcp' ) && ! getCookie( 'hcp_conf' ) ) {
		hcpConfirmationModal();
	}
}() );

function initOffsiteLinks() {
	jQuery( 'a' ).on( 'click', function( event ) {
		const url = jQuery( this ).attr( 'href' );
		// check if the url starts with http. if it does, check if the url contains the current site url. if it doesn't, open in new tab
		console.log(url.indexOf( 'catalystpharma.com' ));
		if ( url.indexOf( 'http' ) == 0 && url.indexOf( window.location.hostname ) == -1 && url.indexOf( 'catalystpharma.com' ) == -1) {
			//if url is pdf, dont trigger modal
			if ( url.indexOf( '.pdf' ) > -1 ) {
				return;
			}
			event.preventDefault();
			globalOffsiteModal( url );
		}
	} );
}

function globalOffsiteModal( url ) {
	const offsiteTemplate = `<div class="modal" id="global-modal">
								<div class="modal-content text-center">
									<button class="close close-x" aria-label="Close" type="button">
										<span aria-hidden="true">×</span>
									</button>
									<h2 class="modal-heading">You Are Now Leaving This Website</h2>
									<p>Do you want to continue?</p>
									<a role="button" class="blue-button close" href="#" aria-label="Close modal" type="button">Go back</a>
									<a role="button" class="blue-button " target="_blank" href="${ url }" type="button">Continue</a>
								</div>
							</div>`;
	jQuery( 'body' ).append( offsiteTemplate );
	const modal = jQuery( '#global-modal' );
	jQuery( '#global-modal .close' ).on( 'click', function() {
		jQuery( '#global-modal' ).remove();
	} );
}

function hcpModal() {
	const offsiteTemplate = `<div class="modal" id="global-modal">
								<div class="modal-content text-center">
									<h2 class="modal-heading">Important Notice</h2>
									<p>This site is for healthcare professionals based in the United States and is for informational purposes only.</p>
									<p><strong>Are you a healthcare professional based in the United States?</strong></p>
									<a role="button" class="blue-button close" href="#" aria-label="Close modal" type="button">I am a US HCP</a>
									<a role="button" class="blue-button " target="_blank" href="https://catalystpharma.com/" type="button">I am a non-US HCP</a>
									<a role="button" class="blue-button " target="_blank" href="https://catalystpharma.com/patient-focus/" type="button">I am a patient/caregiver</a>
								</div>
							</div>`;
	jQuery( 'body' ).append( offsiteTemplate );
	jQuery( '#global-modal .close' ).on( 'click', function() {
		setCookie( 'hcp', 'true', 7 );
		jQuery( '#global-modal' ).remove();
		hcpConfirmationModal();
	} );
}

function hcpConfirmationModal() {
    jQuery.get('/wp-content/themes/mtpress/parts/hcp-confirmation.html', function (data) {
        jQuery('body').append(data);
        
        // Add your event listeners after the modal content is loaded.
		hcpAddEventListeners();
    });
}

function hcpAddEventListeners() {
    jQuery('#hcp-confirmation-form input').on('input', function () {
        // Your input validation logic here
		var inputValidity = jQuery('#hcp-confirmation-form input').filter(function () {
			return !this.value.trim();
		}).length;

		if (!inputValidity) {
			jQuery('#hcp-confirmation-form .submit').addClass('close');
		}
    });

    jQuery('#hcp-confirmation-form').on('submit', function (e) {
		e.preventDefault();
		var formData = jQuery('#hcp-confirmation-form').serialize();
		// Send the AJAX POST request
		var contactListId = '84003';
		var contactListFolderId = '23603';
		formData += '&contactListId=' + contactListId;
		formData += '&contactListFolderId=' + contactListFolderId;
		console.log(formData)
		jQuery.ajax({
			type: 'POST',
			url: 'https://copay.medthink.com/icontact',
			data: formData,
			success: function (response) {
				setCookie('hcp_conf', 'true', 7);
				jQuery('#global-modal').remove();
			},
			error: function (error) {
				// Handle any errors here
				console.error(error);
			}
		});
    });
}

function formRedirect() {
	if ($('input[name="retURL"]').length > 0) {
		$('input[name="retURL"]').val(window.location.origin + $('input[name="retURL"]').val());
	}
}

function setCookie( name, value, days ) {
	const expires = new Date();
	expires.setTime( expires.getTime() + ( days * 24 * 60 * 60 * 1000 ) );
	document.cookie = `${ name }=${ value };expires=${ expires.toUTCString() };path=/`;
}

function getCookie( name ) {
	const cookieName = `${ name }=`;
	const cookieArray = document.cookie.split( ';' );

	for ( let i = 0; i < cookieArray.length; i++ ) {
		let cookie = cookieArray[ i ];
		while ( cookie.charAt( 0 ) === ' ' ) {
			cookie = cookie.substring( 1 );
		}
		if ( cookie.indexOf( cookieName ) === 0 ) {
			return cookie.substring( cookieName.length, cookie.length );
		}
	}
	return null;
}

function setActiveNav() {
	//get end of url path and check if it contains the string from the anchor in .top-nav
	const path = window.location.pathname;

	// if pathname just / skip
	if ( path === '/' ) {
		return;
	}
	const pathArray = path.split( '/' );
	//remove empty strings from array
	pathArray.forEach( ( item, index ) => {
		if ( item === '' ) {
			pathArray.splice( index, 1 );
		}
	} );
	const lastPath = pathArray[ pathArray.length - 1 ];
	const topNav = document.querySelectorAll( '.top-nav a' );
	topNav.forEach( ( link ) => {
		console.log(link.getAttribute( 'href' ))
		console.log( pathArray)
		console.log( link.getAttribute( 'href' ).includes( lastPath ));
		if ( link.getAttribute( 'href' ).includes( lastPath ) ) {
			link.classList.add( 'active' );
		}
	} );
}
